<div class="cm-canvas-container" #canvasContainer>
    <ng-content></ng-content>
    <canvas #canvas class="cm-base-canvas"> </canvas>
</div>
